import DecimalInput from "@/components/DecimalInput";
import DecimalStringInput from "@/components/DecimalStringInput";
import TransformedInput from "@/components/form/TransformedInput.vue";
import ResourceItemInput from "@/components/resource/ResourceItemInput.vue";
import { Checkbox, DatePicker, Input, InputNumber } from "element-ui";
import { FunctionalComponentOptions } from "vue";

import BarcodeInput from "./BarcodeInput";
import { formField } from "./FormField";
import LabeledOptionSelectInput from "./LabeledOptionSelectInput.vue";
import UniversalSelectInput from "./UniversalSelectInput.vue";

export const StringField = formField(Input, "");
export const StringInput = Input;

export const IntegerField = formField(InputNumber, 0);
export const IntegerInput = InputNumber;

export { DecimalStringInput };
export const DecimalStringField = formField(DecimalStringInput, "0.0");

export { DecimalInput };
export const DecimalField = formField(DecimalInput);

export { ResourceItemInput };
export const ResourceItemField = formField(ResourceItemInput);

export const BooleanInput: FunctionalComponentOptions = {
  functional: true,
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  model: {
    event: "input",
    prop: "value",
  },
  render(h, { props: { value }, listeners }) {
    return h(Checkbox, { props: { checked: value }, on: listeners });
  },
};
export const BooleanField = formField(BooleanInput, false);

export const SelectField = formField(UniversalSelectInput, null);
export { LabeledOptionSelectInput };
export const LabeledOptionSelectField = formField(LabeledOptionSelectInput);

export const BarcodeField = formField(BarcodeInput, "");

export { TransformedInput };
export const TransformedInputField = formField(TransformedInput);

export const DateInput = DatePicker;
export const DateField = formField(DatePicker);
